import axios from 'axios';

const initialState = {
    interview: {
        id: null,
        patient_id: null,
        initial_weight: null,
        target_weight: null,
        weight_change_per_week: null,
        height: null,
        activity: null,
        psychological_condition: null,
        symptoms: [],
        diseases: {},
        work: null,
        work_hours: null,
        eating_habits: null,
        previous_diet: null,
        stress: null,
        supplements: null,
        equipments: [],
        other_allergy: null,
        products: [],
        questions: []
    },
    likeables: [],
};

const state = Object.assign({}, initialState);

const getters = {
    interview: state => state.interview,
    hasInterview: state => state.interview.id !== null,
    likeables: state => state.likeables,
};

const actions = {
    async fetchInterview({commit}, payload) {
        const {data} = await axios.get('/v2/patients/' + payload.patientId + '/interview/' + payload.interviewId);
        const interview = data.data;

        commit('setInterview', interview);
    },
    async updateInterview({commit}, interview) {
        const {data} = await axios.patch('/v2/patients/' + interview.patient_id + '/interview/' + interview.id, interview);
        const updatedInterview = data.data;

        commit('setInterview', updatedInterview);
    },
    async createInterview({commit}, interview) {
        const {data} = await axios.post('/v2/patients/' + interview.patient_id + '/interview', interview);
        const newInterview = data.data;

        commit('setInterview', newInterview);
    },
    async fetchLikeables({commit}, payload) {
        const {data} = await axios.get('/v2/patients/' + payload.patientId + '/likeables');
        const likeables = data.data;

        commit('setLikeables', likeables);
    }
};

const mutations = {
    setInterview: (state, interview) => (state.interview = interview),
    setLikeables: (state, likeables) => (state.likeables = likeables),
};

export default {
    state,
    getters,
    actions,
    mutations
};
